import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import CheckmarxSCAConfigListing from './CheckmarxSCAConfigListing';
import CheckmarxSCACredentialForm from './CheckmarxSCACredentialForm';

export default function CheckmarxSCAPullandPushView(props){
    return (
        <GenericPullAndPushToolView
            {...props}
            PullCredentialForm={CheckmarxSCACredentialForm}
            PullConfigListingView={CheckmarxSCAConfigListing}
        />
    )
}